var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.25 3.25C11.25 3.25 10.75 5.25 9.5 5.25C6.75 5.25 7.75 0.75 7.75 0.75C7.75 0.75 5.25 2.25 4.5 6.25C3.5 5.75 3.25 4.25 3.25 4.25C3.25 4.25 1.75 6 1.75 8.75C1.75 14 6.75 14.5 6.75 14.5C6.75 14.5 5.5 13 5.5 11.25C5.5 8.5 6.674 7.25 6.674 7.25C6.674 7.25 6.924 10 8.5 10C9.5 10 10 9.25 10 9.25C10 9.25 11 10.25 11 12C11 13.587 9.75 14.5 9.75 14.5C12.3695 13.9735 14.25 11.5525 14.25 8.7845C14.25 5.5 11.25 3.25 11.25 3.25Z",
    fill: "#FF2D2D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.9f73aa8e16bc25c1560f783354c85ac0.svg";
export { ForwardRef as ReactComponent };